# import InvitationFragment from "../fragments/invitation.graphql"

mutation UpdateInvitation($input: UpdateInvitationInput!) {
  updateInvitation(input: $input) {
    ...InvitationFragment
  }
}
